jQuery(document).ready(function(){ 
    if($('.ph-tamanho')[0]){
        OrderVariants('.ph-tamanho','.swatch-element');
    }

    $('body.template-customers-register').on('click', 'input[type=radio][name="vou_me_cadastrar_como_"]', function () {
        if ($(this).val() == "Aluno") {
            $('.cf-field-container.school-select').slideDown();
        } else {
            $('.cf-field-container.school-select').slideUp();
            if ($('[name="escola"]'))
                $('[name="escola"]').val($('[name="escola"] option')[0].value);
        }
    });

    if (document.body.classList.contains('template-index')) {
        setTimeout(function () {
            var bannerDots = $('.the-index-hero .owl-dots .owl-dot')
                dotsLength = bannerDots.length,
                timer = 7000;

            function autoSlide() {
                bannerDots.each(function (i, elem) {
                    setTimeout(function () {
                        elem.click();
                        if (i == dotsLength - 1) {
                            setTimeout(function () {
                                autoSlide();
                            }, timer);
                        }
                    }, i * timer);
                });
            }
            autoSlide();

        }, 2000);
    }
});

var OrderVariants = function(VariantParent, VariantChild){
    var alphaSize = ['PP','P','P/M','M','G','GG','XG','XXG','EG','EGG','GGG','GGGG','3G','4G'];
    $(VariantParent).each(function(){
        var parentEl = $(this);
        $(this).find(VariantChild).filter(function(){
            var w = $.inArray( $(this).data('value'), alphaSize);
            if (w > -1) {
                $(this).attr('data-sortindex', w);
                return true;
            }
            else {
                if($.isNumeric($(this).data('value'))){
                    $(this).attr('data-sortindex', $(this).data('value'));
                    return true;
                }else{
                    return false;
                }
            }
        })
        .sort(function(a, b){
            return $(a).data('sortindex') - 
                $(b).data('sortindex');
        })
        .appendTo(parentEl);
    });
  }

function maxLengthCheck(object) {
    if (object.value.length > object.maxLength)
        object.value = object.value.slice(0, object.maxLength)
}
    
function isNumeric (evt) {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode (key);
    var regex = /[0-9]|\./;

    if ( !regex.test(key) ) {
        theEvent.returnValue = false;
    if(theEvent.preventDefault) theEvent.preventDefault();
    
    }
}   